import { SEND_TAG_EVENT } from "@/graphql/mutations/tracker";
import { useMutation } from "@apollo/client";

export default function useTagEvent() {
    const [sendTagEvent, { loading }] = useMutation(SEND_TAG_EVENT);

    const sendEvent = (
        eventName,
        { onCompleted = () => {}, onError = () => {}, ...attrs }
    ) => {
        try {
            sendTagEvent({
                variables: {
                    input: {
                        eventName,
                        eventAttributes: JSON.stringify(attrs),
                    },
                },
                onCompleted: () => {
                    onCompleted();
                },
                onError: (err) => {
                    onError(err?.message);
                },
            });
        } catch (e) {
            console.error(`error in send event: ${e}`);
        }
    };

    return {
        loading,
        sendEvent,
    };
}
